import i18next from "i18next";
import cn from "../lang/cn.json";
import en from "../lang/en.json";

export const langEn = "en";
export const langCn = "cn";
const defaultLang = langCn;
export const supportedLanguages = [langEn, langCn];

function fallbackMissingTranslationKey(key: string): string {
  if (!key) {
    return key;
  }

  const keyWithoutNamespace = key.includes(":")
    ? key.split(":").pop() || key
    : key;

  const segments = keyWithoutNamespace.split(".").filter(Boolean);
  if (segments.length > 1) {
    // Scan backwards and merge consecutive segments that together form a numeric value,
    // so that decimal keys like "legend.0.01" (split as ["legend","0","01"]) return "0.01"
    // instead of just "01".
    let startIndex = segments.length - 1;
    while (startIndex > 0) {
      const candidate = segments.slice(startIndex - 1).join(".");
      if (!isNaN(Number(candidate))) {
        startIndex--;
      } else {
        break;
      }
    }
    return segments.slice(startIndex).join(".");
  }

  return keyWithoutNamespace;
}

export function initTranslations(lang?: string): void {
  i18next.init<void>({
    interpolation: { escapeValue: false },
    lng: guardLanguage(lang),
    fallbackLng: supportedLanguages,
    resources: {
      en: en,
      cn: cn,
    },
    defaultNS: "translations",
    saveMissing: true,
    parseMissingKeyHandler: (key: string) => fallbackMissingTranslationKey(key),
    missingKeyHandler: (lng: readonly string[], ns: string, key: string) => {
      console.error(`Missing translation for: ${lng}:${ns}:${key}.`);
      return key;
    },
  });
}

export function guardLanguage(lang?: string): string {
  const lng = (lang || defaultLang).toLocaleLowerCase();
  if (!supportedLanguages.includes(lng)) {
    return defaultLang;
  }
  return lng;
}

export const getLanguage = (): string =>
  guardLanguage(localStorage.getItem("lang") || undefined);

export const setLanguage = (lang: string): void => {
  localStorage.setItem("lang", lang);
};
